const _ACTION_PREFIX = '[frontend/app]';

export const INITIALIZED = `${_ACTION_PREFIX}/INITIALIZED`;
export const ROUTE_CHANGED = `${_ACTION_PREFIX}/ROUTE_CHANGED`;

export const initialized = () => ({
  type: INITIALIZED,
});

export const routeChanged = () => ({
  type: ROUTE_CHANGED,
});
